// src/context/UserContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const userRef = doc(db, "users", firebaseUser.uid);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
          // Existing user
          setUser({
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            organization: userDoc.data().organization,
            organizationId: userDoc.data().organizationId,
            tncAccepted: userDoc.data().tncAccepted ?? false, // default false
          });
        } else {
          // First time login → create doc
          await setDoc(userRef, {
            email: firebaseUser.email,
            organization: "",
            organizationId: "",
            tncAccepted: false,
          });

          setUser({
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            organization: "",
            organizationId: "",
            tncAccepted: false,
          });
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
